import styled from 'styled-components';
import {Tag} from 'antd';

export const StyledMatchedBadgeTag = styled(Tag)`
  &.ant-tag {
    border-radius: 16px;
    color: ${props => props.theme.colors.neutral_9};
  }
`;
